enum TradingPolicyPeriodicitiesEnum {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  FORTNIGHTLY = 'fortnightly',
  MONTHLY = 'monthly',
  CUSTOM = 'custom',
}

export default TradingPolicyPeriodicitiesEnum;
